import PJ from '../js/enumeraciones/pj.js'
import SINOJ from '../js/enumeraciones/sinoj.js'

//Creamos la variable de enumeraciones
const enumeraciones = {};


//Asignamos los datos necesarios del enumeraciones
enumeraciones.EsPrueba = false
enumeraciones.RutaEsRedirigidaPor = {
  EsCasa: 0,
  NoTieneSesion: 1,
  NoTieneAccesoAlSistema: 2,
  NoTieneAccesoALaVentana: 3,
  NoEsRedirigida: 4,
  YaTieneSesion: 5
}
enumeraciones.etiquetasDeHTML = {
  Select: 1,
  Checkbox: 2,
  Radio: 3,
};
enumeraciones.tiposDeSelect = {
  Ninguno: { Id: -2, Nombre: "Ninguno" },
  Ninguna: { Id: -2, Nombre: "Ninguna" },
  Seleccione: { Id: -1, Nombre: "Seleccione" },
  Todos: { Id: 0, Nombre: "Todos" },
  Todas: { Id: 0, Nombre: "Todas" }
}
enumeraciones.acciones = {
  Alta: 1,
  Baja: 2,
  Cambios: 3,
  Detalles: 4
}
enumeraciones.error = {
  E404: '404', 
  E500: '500'
}
enumeraciones.catalogos = {
  TiposEstatusDeLaAudiencia: 1,
  PartidosJudiciales: 2,
  Materias: 3,
  Juzgados: 4,
  Salas: 5,
  Jueces: 6,
  TiposDeDocumentos: 7,
  Consecutivo: 8,
  FechaDeInicio: 9,
  FechaFinal: 10,
  OperadoresDeSala: 11,
  Fecha: 12,
  NumeroExtra: 13,
  Delitos: 14,
  Juicios: 15,
  Tramites: 16,
  Rubros: 17,
  Municipios: 18,
  Entidades: 19,
  Temporalidades: 20,
  EstatusFirma: 21,
  EstatusProcesado: 22,
  Movimientos: 23,
  Bancos: 24,
  Puestos: 25

}
enumeraciones.componentesDeCamaras = {
  Reproducir: 1,
  Finalizar: 2,
  Diseño: 3,
  CambiarSala: 4,
  LineaDeTiempo: 5,
  Probar: 6,
  Comenzar: 7
}
enumeraciones.camaras = {
  Juez: 1,
  Imputado: 2,
  Victima: 3,
  Testigos: 4,
  Protegido: 5,
  Publico: 6,
  Evidencias: 7,
  HandyCam: 8
}

enumeraciones.puestosJuridicos = {
  Juez: 4,
  OperadoresDeSala: 21
}

enumeraciones.puestos = {
  OperadoresDeSala: 226
}

enumeraciones.basesDeDatos = {
  Majat: 2,
  SIOP: 3,  
  Forseti: 14,  
}

enumeraciones.tiposDeTelefonos = {
  Celular: 1,
  Casa: 2,
  Otro: 3,
}
enumeraciones.areasArchivo = {
  General: 21,
  Anexo: 23
}

enumeraciones.TipoEstatusVolumen = {
  Disponible : 1,
  Tramite : 2,
  NoDisponible : 3
}

enumeraciones.adminArchivo = {
  General: 33307,
  Anexo: 33310
}
enumeraciones.TipoTitulo = {
  Certificado: 1,
  Diplomado: 2,
  Trunca: 3
}
enumeraciones.TipoOrden = {
  Materia: 1,
  AreaId: 2,
  Alfabetico: 3
}

//Creamos enum de los sistemas
crearEnumeracionesDeLosSistemas(PJ, "pj");
crearEnumeracionesDeLosSistemas(SINOJ, "sinoj");

//Exportamos los datos de enumeraciones
export default enumeraciones;

//Se define la función que se encargara de hacer el listado de todos los enum
function crearEnumeracionesDeLosSistemas(datosDeLosEnum, nombreSistema) {  
  enumeraciones[nombreSistema] = datosDeLosEnum;  
}



//////////////////
// WEBPACK FOOTER
// ./static/js/enumeraciones.js
// module id = null
// module chunks = 